// TODO => confirm this is different from the majorminor.modal.controller
export default function modalInstanceController($scope, $uibModalInstance, item) {
    $scope.title = item.title;
    $scope.tabs = item.content;

    $scope.ok = () => {
        $uibModalInstance.dismiss();
    }
};